// Minimalny router po hashu. Bez zależności: panel ma pięć zakładek i jeden
// widok szczegółów, a hash sprawia, że odświeżenie strony i link z maila
// trafiają w to samo miejsce.
//
//   #/pulpit            pulpit
//   #/naprawy           lista napraw
//   #/naprawy/<runId>   szczegóły naprawy
//   #/serwery           serwery klienta
//   #/rozliczenia       faktury i zgłoszenia
//   #/admin             panel admina (tylko admin)

import { computed, ref } from "vue";

export type Tab = "pulpit" | "naprawy" | "serwery" | "rozliczenia" | "admin";

export interface Route {
  tab: Tab;
  /** runId w #/naprawy/<runId>, inaczej null. */
  id: string | null;
}

const TABS: Tab[] = ["pulpit", "naprawy", "serwery", "rozliczenia", "admin"];

function parse(hash: string): Route {
  const parts = hash.replace(/^#\/?/, "").split("/").filter(Boolean);
  const tab = (TABS as string[]).includes(parts[0] ?? "") ? (parts[0] as Tab) : "pulpit";
  const id = tab === "naprawy" && parts[1] ? decodeURIComponent(parts[1]) : null;
  return { tab, id };
}

const current = ref<Route>(parse(location.hash));
window.addEventListener("hashchange", () => (current.value = parse(location.hash)));

export const route = computed(() => current.value);

export function go(tab: Tab, id?: string): void {
  const next = id ? `#/${tab}/${encodeURIComponent(id)}` : `#/${tab}`;
  if (location.hash === next) return;
  location.hash = next;
}

export function href(tab: Tab, id?: string): string {
  return id ? `#/${tab}/${encodeURIComponent(id)}` : `#/${tab}`;
}
